import { render, staticRenderFns } from "./NewsPageDetail.vue?vue&type=template&id=6927dd3f&scoped=true&"
import script from "./NewsPageDetail.vue?vue&type=script&lang=ts&"
export * from "./NewsPageDetail.vue?vue&type=script&lang=ts&"
import style0 from "./NewsPageDetail.vue?vue&type=style&index=0&id=6927dd3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6927dd3f",
  null
  
)

export default component.exports